export enum ShippingPartnerIds {
    ThePackengers = 3,
    NationalLogisticServices = 4,
    ChairishAuctions = 7,
    BlueTruck = 8,
}

export const shippingProviders = {
    0: 'one of our shipping partners',
    1: 'Arta',
    2: 'Team World Wide',
    [ShippingPartnerIds.ThePackengers]: 'ThePackengers',
    [ShippingPartnerIds.NationalLogisticServices]: 'National Logistic Services',
    // This is a test id. If you see this on a real auction, hoo boy.
    5: 'ThePackengers',
    // _end test ids
    6: 'Shipping Saint',
    [ShippingPartnerIds.ChairishAuctions]: 'Chairish Auction',
    [ShippingPartnerIds.BlueTruck]: 'Blue Truck Logistics',
} as const;

export type ShippingProviderId = keyof typeof shippingProviders;
